const routes = [
  // {
  //   path: "/brand",
  //   name: authCodeMap.brand,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/brand/case_collection",
  //   meta: {
  //     title: "赋能",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.brand,
  //   },
  //   children: [
  //     {
  //       path: "case_collection",
  //       name: authCodeMap.brand_case_collection,
  //       component: (): any => import("@/modules/brand/pages/caseCollection/index.vue"),
  //       meta: {
  //         title: "赋能_病例征集",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.brand_case_collection,
  //       },
  //       children: [
  //         {
  //           path: "case_activity",
  //           name: authCodeMap.brand_case_activity,
  //           component: (): any => import("@/modules/brand/pages/caseCollection/caseActivity/index.vue"),
  //           meta: {
  //             title: "赋能_病例征集_病例活动",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.brand_case_activity,
  //           },
  //         },
  //         {
  //           path: "case_activity_add",
  //           name: authCodeMap.brand_case_activity_add,
  //           component: (): any => import("@/modules/brand/pages/caseCollection/caseActivity/add.vue"),
  //           meta: {
  //             title: "赋能_病例征集_病例活动_新增",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.brand_case_activity_add,
  //           },
  //         },
  //         {
  //           path: "case_activity_detail",
  //           name: authCodeMap.brand_case_activity_Detail,
  //           component: (): any => import("@/modules/brand/pages/caseCollection/caseActivity/detail.vue"),
  //           meta: {
  //             title: "赋能_病例征集_病例活动_详情",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.brand_case_activity_Detail,
  //           },
  //         },
  //         {
  //           path: "case_manager",
  //           name: authCodeMap.brand_case_manager,
  //           component: (): any => import("@/modules/brand/pages/caseCollection/caseManager/index.vue"),
  //           meta: {
  //             title: "赋能_病例征集_病例管理",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.brand_case_manager,
  //           },
  //         },
  //       ],
  //     },
  //     {
  //       path: "meetCenter_index",
  //       name: authCodeMap.brand_meetCenter,
  //       component: (): any => import("@/modules/brand/pages/meetCenter/index.vue"),
  //       meta: {
  //         title: "赋能_会议中心",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.brand_meetCenter,
  //       },
  //     },
  //     {
  //       path: "meetCenter_edit",
  //       name: authCodeMap.brand_meetCenter_edit,
  //       component: (): any => import("@/modules/brand/pages/meetCenter/edit.vue"),
  //       meta: {
  //         title: "赋能_会议中心_新增学术会议",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.brand_meetCenter_edit,
  //       },
  //       props: (route) => {
  //         return {
  //           id: route.query.id,
  //         };
  //       },
  //     },
  //   ],
  // },
];
export default routes;